// extracted by mini-css-extract-plugin
export default {"root":"CellText_root__ibMz6","ellipsis":"CellText_ellipsis__n+GOS"};